import styled from 'foundations-theming/utils';
const Spacer = styled.div.withConfig({
  displayName: "Spacer"
})(({
  height,
  marginBlock,
  paddingInline,
  theme
}) => ({
  height: height || theme.space[100],
  marginBlock: marginBlock ? theme.space[marginBlock] : '0',
  paddingInline: paddingInline ? theme.space[paddingInline] : '0'
}));
export default Spacer;